// extracted by mini-css-extract-plugin
export default {"container":"styles_container__EI5nY","header":"styles_header__Z2Stu","upSide":"styles_upSide__rZUm3","upSideButton":"styles_upSideButton__mnDuE","name":"styles_name__oMgtE"};